import authFetch from './authFetch';

const request = async (url, options) => {
  const response = await authFetch(url, {
    cache: 'default',
    credentials: 'same-origin',
    ...options,
  });

  if (!response.ok) {
    throw await response.json();
  }
  if (response.status === 204) {
    return;
  }

  const result = await response.json();

  if (!result.status) {
    throw new Error(result.error.message);
  }

  return result;
};

// PHP API may return empty objects as arrays... :(
const normalize = obj => {
  if (Array.isArray(obj)) obj = {};
  return obj;
};

export default {
  getAll: async function() {
    return request('/api/collections/memberCollections', {
      method: 'GET',
    }).then(res => {
      // eslint-disable-next-line no-unused-vars
      const { status, ...data } = res;
      data.collections = normalize(data.collections);
      data.contentModels = normalize(data.contentModels);
      Object.keys(data.collections).forEach(key => {
        data.collections[key].content = normalize(
          data.collections[key].content
        );
      });
      return data;
    });
  },

  create: async function(title) {
    return request('/api/collections/createCollection', {
      method: 'POST',
      body: JSON.stringify({ title: title }),
    }).then(res => {
      const { collection } = res;
      collection.content = normalize(collection.content);
      return collection;
    });
  },

  addTo: function(contents, collectionId) {
    return request('/api/collections/addToMemberCollection', {
      method: 'POST',
      body: JSON.stringify({
        collectionId: collectionId,
        content: contents,
      }),
    });
  },

  removeFrom: function(contentType, contentId, collectionId) {
    return request('/api/collections/removeFromMemberCollection', {
      method: 'POST',
      body: JSON.stringify({
        collectionId: collectionId,
        content: [{ type: contentType, id: contentId }],
      }),
    });
  },
};
